import { ReactNode } from 'react';
import {
  Collapse as MUICollapse,
  CollapseProps as MUICollapseProps,
} from '@mui/material';

type AtomMUIProps = {
  children: ReactNode;
  in?: boolean;
  timeout?: any;
  unmountOnExit?: boolean;
};

export type CollapseProps = AtomMUIProps;

export const Collapse = (props: CollapseProps) => {
  const MUIProps: MUICollapseProps = props;

  return <MUICollapse {...MUIProps} />;
};

export default Collapse;
